import { envConfig } from '../../../../env';
import { Post } from '@/service/request/server';

const baseUrl = envConfig.formalServer + "/cotton/admin/projectSetting/"

export function insertProjectSetting(data) {
    return Post(baseUrl + "insertProjectSetting", data)
}

export function deleteProjectSetting(data) {
    return Post(baseUrl + "deleteProjectSetting", data)
}

export function updateProjectSetting(data) {
    return Post(baseUrl + "updateProjectSetting", data)
}

export function queryProjectSetting(data) {
    return Post(baseUrl + "queryProjectSetting", data)
}

